import React from "react";
//#region types
import { DrillDownTableBaseRowProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import { TableCell, TableRow } from "@mui/material";
import ExpandableCell from "../cells/expandableCell";
import RowTitleTextCell from "../cells/rowTitleTextCell";
import RepeatCells from "../cells/repeatCells";
import TotalCell from "../cells/totalCell";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const DrillDownTableBaseRow: React.FC<DrillDownTableBaseRowProps> = (props) => {
  const {
    row,
    index,
    depth,
    repeatPropertyKey,
    repeatPropertiesList,
    repeatPropertiesLength,
    repeatColumnLength,
    rowTextProperty,
    className,
    expandable,
    showTotal,
    onClickRow,
    expanded = false,
    inlineExpansion,
    sumNegative,
    sumValueRow,
    noExpandableSiblingRows,
  } = props;

  return (
    <TableRow
      hover
      className={clsx(
        cssExports.tableRow,
        depth > 0 ? cssExports.nestedTableSubRows : "",
        depth === 1 ? cssExports.nestedTableSubRowMain : "",
        depth > 1 ? cssExports.nestedTableSubRowsLowerTier : "",
        className
      )}
      classes={{ hover: cssExports.tableRowHover }}
      style={{
        cursor: onClickRow ? "pointer" : "auto",
      }}
      onClick={onClickRow}
    >
      {/* first cell - empty */}
      <TableCell
        key={`tab-headerTop`}
        className={clsx(cssExports.tableCell, cssExports.emptyCell, cssExports.first)}
        onClick={(e: any) => {
          e.stopPropagation();
        }}
      ></TableCell>

      {/* second cell - expandable */}
      {depth === 0 && expandable && !inlineExpansion ? (
        <ExpandableCell expanded={expanded} className={cssExports.second} />
      ) : (
        <TableCell className={clsx(cssExports.tableCell, cssExports.second)} />
      )}

      {/* third cell - expandable or title */}
      {depth === 1 && expandable && !inlineExpansion ? (
        <ExpandableCell expanded={expanded} className={cssExports.third} />
      ) : depth === 0 ? (
        <RowTitleTextCell
          row={row}
          index={index}
          depth={depth}
          propertyName={rowTextProperty.key.toString()}
          cellValue={rowTextProperty.properties}
          className={clsx(cssExports.tableCell, cssExports.third)}
          inlineExpansion={expandable && inlineExpansion}
          colSpan={2}
          expanded={expanded}
        />
      ) : depth === 1 && noExpandableSiblingRows ? (
        <RowTitleTextCell
          row={row}
          index={index}
          depth={depth}
          propertyName={rowTextProperty.key.toString()}
          cellValue={rowTextProperty.properties}
          className={clsx(cssExports.tableCell, cssExports.third)}
          inlineExpansion={expandable && inlineExpansion}
          expanded={expanded}
          colSpan={2}
        />
      ) : (
        <TableCell className={clsx(cssExports.tableCell, cssExports.third)} />
      )}

      {/* fourth cell - title */}
      {depth > 0 && !(depth === 1 && noExpandableSiblingRows) ? (
        <RowTitleTextCell
          row={row}
          index={index}
          depth={depth}
          propertyName={rowTextProperty.key.toString()}
          cellValue={rowTextProperty.properties}
          className={clsx(cssExports.tableCell, cssExports.fourth)}
          inlineExpansion={expandable && inlineExpansion}
          expanded={expanded}
        />
      ) : (
        <></>
      )}

      {repeatPropertiesList && repeatPropertyKey ? (
        <RepeatCells
          index={index}
          depth={depth}
          row={row}
          repeatPropertyKey={repeatPropertyKey}
          repeatPropertiesList={repeatPropertiesList}
          repeatPropertiesLength={repeatPropertiesLength}
          repeatColumnLength={repeatColumnLength}
          showTotal={!!showTotal}
          sumNegative={sumNegative}
          sumValueRow={sumValueRow}
        />
      ) : (
        <></>
      )}

      {/* total cell */}
      {showTotal && repeatPropertyKey ? (
        <TotalCell
          index={index}
          depth={depth}
          row={row}
          repeatPropertyKey={repeatPropertyKey}
          repeatColumnLength={repeatColumnLength}
          showTotal={showTotal}
        />
      ) : (
        <></>
      )}

      {/* last cell - empty */}
      <TableCell className={clsx(cssExports.tableCell, cssExports.emptyCell, cssExports.last)}></TableCell>
    </TableRow>
  );
};

export default DrillDownTableBaseRow;
